import { Injectable } from '@angular/core';
import { ResolutionService } from '@app/shared/common/notification-resolver/resolution-service';
import { AppGlobals } from '@shared/AppGlobals';
import { UUID } from 'angular2-uuid';

@Injectable()
export class Correlator {

    static CORRELATION_ID_HEADER = 'X-Correlation-Id';

    constructor(private resolutionService: ResolutionService) {}

    get generateId(): string {
        this.Id = UUID.UUID();
        this.resolutionService.addCorrelationIdInPageState(this.Id);
        return this.Id;
    }

    set Id(uuid: string) {
        AppGlobals.correlatorId = uuid;
    };

    get Id() {
        return AppGlobals.correlatorId;
    };
}
